/**
 * @typedef {{product: Object, quantity: number, options: number[][]}} ProductItem
 */

const { createApp, ref } = Vue;

let loggerDebug = false;

function logger(...data) {
  if (loggerDebug) console.log(...data);
}

let shopGuideVue = new Vue({
  el: '.main-shop-guide',
  delimiters: ['${', '}'],
  data() {
    return {
      currentStep: 1,
      totalStep: 3,
      questionList: [
        {
          question: "How interested are you in the detector?",
          questionSmallText: "(Multiple choice)",
          options: [
            "Smoke and fire",
            "Carbon monoxide poisoning",
            "Gas Leak",
            "Abnormal temperature",
            "Video surveillance",
          ],
          multipleChoose: true,
        },
        {
          question: "How interested are you in the detector?",
          options: [
            "After installing, I won't pay attention.",
            "likeDIY",
            "I am often not at home and need to control it through my mobile phone.",
          ],
          multipleChoose: false,
        },
        {
          question: "How interested are you in the detector?",
          options: [
            "After installing, I won't pay attention.",
            "likeDIY",
            "I am often not at home and need to control it through my mobile phone.",
          ],
          multipleChoose: false,
        }
      ],
      // 翻译文案
      productTranslate: {},
      /** @type {ProductItem} */
      productList: [
        {
          product: {},
          options: [[0], [], []],
        }
      ],
      /** @type {ProductItem} */
      resultProducts: [],
      // 已选项（单选、多选的索引）
      chooseIndexOptions: [
        // [0], [0], [0]
      ],
      // 面积选项列表
      areaOptions: [],
      // 面积选项在哪个问题出现
      areaForQuestionNumber: 3,
      // 面积选择的选项
      selectedAreaOptionIndex: 0,
      addToCartLoading: false,
    }
  },
  computed: {
    isShowResult() {
      return this.currentStep > this.totalStep;
    },
    // 选择的面积对应的产品 Quantity
    selectQuantity() {
      return this.areaOptions[this.selectedAreaOptionIndex].settings.quantity;
    },
  },
  beforeMount() {
    this.initData();
  },
  mounted() {
  },
  watch: {
    currentStep(step) {
      if (step > this.totalStep) {
        this.takeResultProducts();
      }
    },
  },
  methods: {
    // 初始化数据
    initData() {
      // 问题、选项数据
      const mainScript = document.querySelector(`script[data-shop-guide-main]`);
      const mainScriptJson = JSON.parse(mainScript.innerHTML);
      this.areaForQuestionNumber = mainScriptJson.area_for_question_number;

      const questionsJson = mainScriptJson.blocks.filter((v) => v.type == 'question');
      this.totalStep = questionsJson.length;
      this.questionList = [];
      // Questions
      for (const item of questionsJson) {
        const questionObject = {
          question: item.settings.question,
          questionSmallText: item.settings.question_small_text,
          multipleChoose: item.settings.multiple_choice,
          options: [],
        };
        for (let i = 1; i <= 10; i++) {
          const key = `option_${i}`;
          const value = item.settings[key];
          if (value != null && value != '') questionObject.options.push(value);
        }
        this.questionList.push(questionObject);
      }
      // Area options
      const areaOptionsJson = mainScriptJson.blocks.filter((v) => v.type == 'area_option');
      this.areaOptions = areaOptionsJson;

      // 产品数据
      const productsScript = document.querySelector(`script[data-shop-guide-products]`).innerHTML.replace('},]', '}]');
      const productsJson = JSON.parse(productsScript);
      this.productTranslate = productsJson.translate;
      this.productList = [];
      for (const item of productsJson.blocks) {
        const productObject = {
          product: item.product,
          quantity: 1,
          settings: item.settings,
          options: [],
        };
        // 转换 certifications_icon*
        productObject.settings.certifications_icon_list = [];
        for (let i = 1; i <= 10; i++) {
          const key = `certifications_icon_${i}`;
          const icon = productObject.settings[key];
          if (icon != null && icon != '') {
            productObject.settings.certifications_icon_list.push(icon);
          }
        }
        for (let i = 1; i <= 10; i++) {
          const key = `options_${i}`;
          // 转换 'A' => 0, "B" => 1 ...
          const list = (item.settings[key] != undefined && item.settings[key] != '') ? item.settings[key].split(',').map((v) => v.trim().toUpperCase().charCodeAt() - 65) : [];
          productObject.options.push(list);
        }
        this.productList.push(productObject);
      }
      console.log(this.productList)
    },
    // 展示结果
    takeResultProducts() {
      if (this.chooseIndexOptions.length < (this.totalStep - 1)) return [];
      const products = this.productList.filter((value, index) => {
        let isResult = true;
        for (let i = 0; i < this.totalStep; i++) {
          // 没指定 options，那就是任意选项均通过
          if (value.options[i].length == 0) continue;
          // 产品设置的选项和已选项没有交集，就不通过
          const set = new Set([...value.options[i], ...this.chooseIndexOptions[i]]);
          if (set.size == value.options[i].length + this.chooseIndexOptions[i].length) {
            isResult = false;
          }
        }
        return isResult;
      });
      products.forEach((v) => v.quantity = this.selectQuantity);
      console.log(products);
      this.resultProducts = products;
    },
    /**
     * 上一步
     */
    handleClickPrevious() {
      if (this.currentStep > 1) {
        this.currentStep--;
      } else {
        this.currentStep = 1;
      }
    },
    /**
     * 下一步
     */
    handleClickNextStep() {
      if (this.currentStep <= this.totalStep) {
        this.currentStep++;
      } else {
        this.currentStep = this.totalStep;
      }
    },
    /**
     * 重置
     */
    handleClickReset() {
      this.currentStep = 1;
      this.chooseIndexOptions = [];
    },
    /**
     * 点击选项
     */
    handleClickOption(_, index) {
      const stepIndex = this.currentStep - 1;
      const multipleChoose = this.questionList[stepIndex].multipleChoose;
      if (multipleChoose) {
        const set = new Set(this.chooseIndexOptions[stepIndex]);
        set.has(index) ? set.delete(index) : set.add(index);
        this.chooseIndexOptions[stepIndex] = [...set];
      } else {
        this.chooseIndexOptions[stepIndex] = [index];
      }
      this.chooseIndexOptions = [...this.chooseIndexOptions];
    },
    /**
     * 点击面积子选项
     */
    handleClickAreaOption(_, index) {
      this.selectedAreaOptionIndex = index;
    },
    /**
     * 改变产品数量的回调
     * @param {ProductItem} item 
     */
    handleQuantityChange(e, item) {
      const value = e.target.value;
      const quantity_rule = item.product.selected_or_first_available_variant?.quantity_rule;
      const min = quantity_rule?.min;
      const max = quantity_rule?.max;
      const findProductItem = this.resultProducts.find((v) => v.product.id == item.product.id);
      if (min != null && value <= min) {
        findProductItem.quantity = min;
      } else if (value <= 0) {
        findProductItem.quantity = 1;
      }
      if (max != null && value >= max) {
        findProductItem.quantity = max;
      }
    },
    /**
     * 减少产品数量
     * @param {ProductItem} item 
     */
    handleQuantityDecrease(item) {
      const quantity_rule = item.product.selected_or_first_available_variant?.quantity_rule;
      const min = quantity_rule?.min;
      const findProductItem = this.resultProducts.find((v) => v.product.id == item.product.id);
      console.log(item)
      if (min != null && item.quantity <= min && item.quantity > 1) {
        findProductItem.quantity = min;
      } else if (item.quantity <= 1) {
        findProductItem.quantity = 1;
      } else {
        findProductItem.quantity = item.quantity - 1;
      }
    },
    /**
     *增加产品数量
     * @param {ProductItem} item 
     */
    handleQuantityIncrease(item) {
      const quantity_rule = item.product.selected_or_first_available_variant?.quantity_rule;
      const max = quantity_rule?.max;
      const findProductItem = this.resultProducts.find((v) => v.product.id == item.product.id);
      if (max != null && item.quantity >= max) {
        findProductItem.quantity = max;
      } else {
        findProductItem.quantity = item.quantity + 1;
      }
    },
    handleAddCart() {
      let formData = {
        items: [],
      };
      for (const productItem of this.resultProducts) {
        if (productItem.product.available) {
          formData.items.push({
            id: productItem.product.selected_or_first_available_variant.id,
            quantity: productItem.quantity,
          });
        }
      }
      this.addToCartLoading = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(result => {
          console.log(result);
          document.querySelector('[aria-controls="CartDrawer"]').click();
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          this.addToCartLoading = false;
        });
    }
  }
});